// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__vrZhj","myModalContent":"MyModal_myModalContent__RfrMF","active":"MyModal_active__Mh-j3"};